import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import styled from 'styled-components';
import { Defect } from '../../../models/defects';
import TFTooltip from '../../TFTooltip/TFTooltip';
import FlexWrapper from './FlexWrapper';
import Label from './Label';
import StyledInput from './StyledInput';

interface RectificationLimitsProps {
  defect: Defect | null;
  setCalendarDays: (value: string) => void;
  apuInstalled: boolean;
}

const BorderLine = styled.div`
  width: 640px;
  height: 1px;
  background-color: rgba(36, 45, 65, 0.05);
  margin-top: ${({ marginTop }): string => (marginTop ? `${marginTop}` : '')};
`;

const RectificationLimits: React.FC<RectificationLimitsProps> = ({ defect, setCalendarDays, apuInstalled }) => {
  const [showCatAInfo, setShowCatAInfo] = useState(false);
  const { formatMessage } = useIntl();

  const handleCalendarDaysChange = (value: string): void => {
    setCalendarDays(value);
  };

  const onMouseEnterDefer = (): void => {
    setShowCatAInfo(true);
  };

  const onMouseLeaveDefer = (): void => {
    setShowCatAInfo(false);
  };

  return (
    <div id="rectificationLimits">
      <BorderLine marginTop="20px" />
      <FlexWrapper column marginTop={20}>
        <FlexWrapper>
          <Label fontWeight={500} marginBottom={15} marginRight={5}>
            {formatMessage({ id: 'title.enterRectificationIntervals' })}
          </Label>
          <TFTooltip
            handleMouseOver={onMouseEnterDefer}
            handleMouseLeave={onMouseLeaveDefer}
            showToolTip={showCatAInfo}
          >
            <span>{formatMessage({ id: 'text.allowedRectificationIntervals' })}</span>
          </TFTooltip>
        </FlexWrapper>
        <Label color="rgba(36, 45, 65, 0.7)" marginBottom={20}>
          {formatMessage({ id: 'text.pleaseEnterRectificationInterval' })}
        </Label>
        <FlexWrapper flexWrap="wrap">
          <FlexWrapper column marginRight={20} marginBottom={20}>
            <Label marginBottom={5}>{formatMessage({ id: 'form.labels.flightHourLimit' })}</Label>
            <StyledInput
              defaultValue={defect?.flight_seconds_limit / 3600 || ''}
              type="text"
              width={140}
              id="flightHoursLimit"
            />
          </FlexWrapper>
          {apuInstalled ? (
            <FlexWrapper column marginRight={20} marginBottom={20}>
              <Label marginBottom={5}>{formatMessage({ id: 'form.labels.apuHoursLimit' })}</Label>
              <StyledInput
                defaultValue={defect?.apu_seconds_limit / 3600 || null}
                type="text"
                width={140}
                id="APUHoursLimit"
              />
            </FlexWrapper>
          ) : null}
          <FlexWrapper column marginRight={20} marginBottom={20}>
            <Label marginBottom={5}>{formatMessage({ id: 'form.labels.flightDaysLimit' })}</Label>
            <StyledInput defaultValue={defect?.flight_days_limit || ''} type="text" width={140} id="flightDaysLimit" />
          </FlexWrapper>
          <FlexWrapper column marginRight={20} marginBottom={20}>
            <Label marginBottom={5}>{formatMessage({ id: 'form.labels.calendarHoursLimit' })}</Label>
            <StyledInput defaultValue={defect?.seconds_limit / 3600 || ''} type="text" width={140} id="hoursLimit" />
          </FlexWrapper>
          <FlexWrapper column marginRight={20} marginBottom={20}>
            <Label marginBottom={5}>{formatMessage({ id: 'form.labels.calendarDaysLimit' })}</Label>
            <StyledInput
              defaultValue={defect?.calendar_days_limit || ''}
              type="text"
              width={140}
              onChange={(e): void => handleCalendarDaysChange(e.target.value)}
              id="calendarDaysLimit"
            />
          </FlexWrapper>
          <FlexWrapper column marginRight={20} marginBottom={20}>
            <Label marginBottom={5}>{formatMessage({ id: 'form.labels.cyclesLimit' })}</Label>
            <StyledInput defaultValue={defect?.cycles_limit || ''} type="text" width={140} id="cyclesLimit" />
          </FlexWrapper>
          <FlexWrapper column marginRight={20} marginBottom={20}>
            <Label marginBottom={5}>{formatMessage({ id: 'form.labels.flightLimit' })}</Label>
            <StyledInput defaultValue={defect?.flights_limit || ''} type="text" width={140} id="flightLimit" />
          </FlexWrapper>
          <FlexWrapper column marginRight={20} marginBottom={20}>
            <Label marginBottom={5}>{formatMessage({ id: 'form.labels.otherLimit' })}</Label>
            <StyledInput defaultValue={defect?.other_limit || ''} type="text" width={140} id="otherLimit" />
          </FlexWrapper>
        </FlexWrapper>
      </FlexWrapper>
    </div>
  );
};

export default RectificationLimits;
